/**
 * External Dependencies
 */
// import 'jquery';
// import 'fabric';
// import html2canvas from 'html2canvas';


// $(document).ready(() => {
//   jQuery('.loading').fadeOut();
// });

// // Variables
// let paintingViewer = null;
// let canvas = null;
// let painting = null;
// let paintingImg = null;
// let wall = null;
// let wallImg = null;
// let wallList = null;
// let wallWidthCM = null;
// let CMinCanvas = null;
// let ownImageInput = null;
// let CMinPainting = null;
// let sizeScaling = 1;
// const framesWidth = jQuery('#original-painting').data('frames') ? 3 : 0;

// // Resize canvas
// const resizeCanvas = (scaling, sizeScaling = null) => {
//   canvas.setWidth(wall.width());
//   canvas.setHeight(wall.height());

//   if(sizeScaling == 0) {
//     sizeScaling = 1;
//   }

//   CMinCanvas = wall.width() / wallWidthCM * sizeScaling;

//   addPaintingToCanvas(scaling);
// }

// // Add painting
// const addPaintingToCanvas = (scaling) => {
//   canvas.clear()

//   const shadow = new fabric.Shadow({
//     affectStroke: false,
//     color: 'rgba(0,0,0,0.3)',
//     blur: 20,
//     nonScaling: true,
//     offsetX: 4,
//     offsetY: 4,
//   });

//   const fabricPainting = new fabric.Image(jQuery('#painting-image')[0], {
//     left: 0,
//     top: 0,
//     shadow: shadow
//   });

//   const paintingWidth = paintingImg.data('width') * CMinCanvas;

//   fabricPainting.scaleToWidth(paintingWidth);

//   fabricPainting.set({
//     originX: "center",
//     originY: "center"
//   });

//   const group = new fabric.Group([fabricPainting], {
//     left: 0,
//     top: 50,
//     hasControls: scaling,
//     lockScalingFlip: true,
//     lockRotation: true,
//     lockSkewingX: true,
//     lockSkewingY: true,
//     borderColor: 'transparent'
//   });

//   group.center();

//   group.setPositionByOrigin({ x: canvas.width / 2, y: group.height / 2 + canvas.height / 100 * 10 }, 'center', 'center');
//   group.setCoords();

//   canvas.add(group);
//   canvas.renderAll();

//   canvas.setActiveObject(group);
// }

// const changeWall = (newWall) => {
//   if (!newWall.hasClass('active')) {

//     if (newWall.hasClass('own-image')) {
//       ownImageInput.trigger('click');
//     } else {
//       wallList.removeClass('active');
//       newWall.addClass('active');

//       if (newWall.hasClass('painting')) {
//         painting.addClass('active');
//         wall.removeClass('active');
//       } else {
//         painting.removeClass('active');
//         wall.addClass('active');
//         wallWidthCM = newWall.data('width');
//         wallImg.attr('data-width', newWall.data('width'));
//         wallImg.attr('src', newWall.attr('href'));
//         sizeScaling = newWall.data('scaling');
//         resizeCanvas(false, sizeScaling);
//       }
//     }
//   }
// }

// const ownWall = () => {
//   const reader = new FileReader();

//   reader.onload = function (e) {
//     wallImg.attr('src', e.target.result);
//     painting.removeClass('active');
//     wall.addClass('active');
//   }

//   reader.onloadend = function (e) {
//     wallList.removeClass('active');
//     resizeCanvas(true);
//   }

//   reader.readAsDataURL(ownImageInput[0].files[0]); // convert to base64 string

// }

// $(document).ready(() => {

//   // Get dom elements
//   paintingViewer = jQuery('.painting-viewer');
//   painting = jQuery('.painting-viewer__painting', paintingViewer);
//   paintingImg = jQuery('img', painting);
//   wall = jQuery('.painting-viewer__wall', paintingViewer);
//   wallImg = jQuery('img', wall);
//   wallList = jQuery('.painting-viewer__wall-list a', paintingViewer);
//   ownImageInput = jQuery('#own-image-input', paintingViewer);

//   // Init fabric
//   canvas = new fabric.Canvas('wall');
//   jQuery('#c1', paintingViewer).removeClass('disabled');

//   // Get wall width
//   wallWidthCM = wallImg.data('width');

//   // Trigger resizeCanvas
//   resizeCanvas(false);

//   // Add event listener for window resize
//   // window.addEventListener('resize', resizeCanvas);

//   // Add event listeners for changing the wall
//   wallList.each(function (index) {
//     jQuery(this).on('click', function (e) {
//       e.preventDefault();
//       changeWall(jQuery(this));
//     });
//   });

//   // Add event listener for file input change
//   ownImageInput.on('change', function () {
//     ownWall();
//   });

//   CMinPainting = paintingImg[0].naturalWidth / paintingImg.data('width');

//   if (jQuery('#original-painting').data('frames')) {
//     // HERE YOU CAN GIVE FRAME SIZE IN CM!!!
//     jQuery('#original-painting .frames').css({
//       'padding': framesWidth * CMinPainting + 'px'
//     });
//   }

//   if (jQuery('#original-painting').data('passepartout')) {
//     const passepartoutWidth = jQuery('#original-painting').data('passepartout') * CMinPainting;
//     jQuery('#original-painting .passepartout').css({
//       'padding': passepartoutWidth + 'px'
//     });
//   }

//   jQuery('.loading').fadeIn();

//   html2canvas(jQuery("#original-painting")[0], {
//     onclone: function (clonedDoc) {
//       jQuery('#original-painting', clonedDoc).show();
//     }
//   }).then((canvas) => {
//     var imgsrc = canvas.toDataURL();
//     jQuery('#painting-image').attr('src', imgsrc);
//     jQuery('.loading').fadeOut();
//   });

// });


// $(function() {
  var init = false
  
  var canvas_width = $('#c1').width();
  var art_scale = $('.bg').first().data('scaling');
  var art_height = $('#object').data('height')*10;
  var art_width = $('#object').data('width')*10;
  var art_paspaper = $('#object').data('passepartout')*10;
  var art_paspaper_color = "#F5F5F1"
  var art_frame = $('#object').data('frame')*10;
  var art_frame_color = $('#object').data('framecolor');
  var art_is_frame = $('#object').data('isframe');
  var art_is_paspaper = $('#object').data('ispasspartout');
  var container_width = $('.paint-container').width();
  
  var canvas = document.getElementById("c1");

  if(canvas) {
    var ctx = canvas.getContext("2d");
    var canvasOffset = $("#c1").offset();
    var scrollOffset = $(window).scrollTop();
    var offsetX = canvasOffset.left;
    var offsetY = canvasOffset.top-scrollOffset;
  
    var mouseIsDown = false;
    var lastX = 50;
    var lastY = 50;
    var mouseX = 0;
    var mouseY = 0;
    
    var arts = [];
    
    var ob_image = new Image();
    ob_image.src = $('#object').attr('src');


    $('#c1').css('background-image', 'url("'+ $('.bg').first().attr('src') + '")');
    hideCanvas();

    $(document).on('click', '.bg, #uploadPreview', function() {
    // $('.bg, #uploadPreview').on('click', function() {
      activeItem(this);
      $('#topline').val("10");
      $('#bottomline').val("70");
      $('#wall_height').val("2500");
      $('.art-preview-container').hide();
      customThumb();

      $('#c1').css('background-image', 'url("'+ $(this).attr('src') + '")');
      console.log($('#c1').css('background-image', 'url("'+ $(this).attr('src') + '")'));
      art_scale = $(this).data('scaling');

      if($(this).hasClass('upload-bg')) {
        $('#c1').show();
        $('.canvas-range-container').show();
        $('.wall-height-container').show();
        canvaResize();
        canvaOnScroll();
      } else {
        $('#c1').show();
        $('.canvas-range-container').hide();
        $('.wall-height-container').hide();
        canvaResize();
        canvaOnScroll();
      }
      init = false;
      


      // initCanvasSize();
      // initObject();
    })

    $(document).on('click', '.object', function() {
      hideCanvas();
      activeItem(this);
      var art_img_src = $(this).prop('src');
      $('.art-preview-container img').attr('src', art_img_src);
      $('.art-preview-container').show();
      //wp_get_attachment_image_src($post_thumbnail_id, 'large')[0]
    })

    $(document).on('input', '#uploadImage', function() {
      var oFReader = new FileReader();
      oFReader.readAsDataURL(document.getElementById("uploadImage").files[0]);

      oFReader.onload = function (oFREvent) {
          $('.art-preview-container').hide();
          art_scale = 1;
          customThumb();
          $('.bg').last().after('<img data-scaling="1" class="bg upload-bg" src="'+ oFREvent.target.result +'" alt="kuva">')
          $('#c1').css('background-image', 'url("'+ oFREvent.target.result + '")');
          $('#c1').show();
          $('.canvas-range-container').show();
          $('.wall-height-container').show();
          container_width = $('.paint-container').width();
          canvas_width = container_width;
          activeItem($('.bg').last());
          //initCanvasSize();
          canvaResize();
          canvaOnScroll();
      };
    });

    function activeItem(active) {
      $('.object').removeClass('active');
      $('.bg').removeClass('active');
      $(active).addClass('active');
    }

    function hideCanvas() {
      $('.canvas-range-container').hide();
      $('.wall-height-container').hide();
      $('#c1').hide();
    }


    customThumb();

    function customThumb() {
      var topline_value = $('#topline').val();
      var bottomline_value = $('#bottomline').val();
      
      var top_thumb = $('#topline_thumb');
      var bottom_thumb = $('#bottomline_thumb');
      
      top_thumb.css('top', topline_value+'%');
      bottom_thumb.css('top', bottomline_value+'%');
    }
    $( window ).on('scroll', function() {
      canvaOnScroll();
    });

    function canvaOnScroll() {
      canvasOffset = $("#c1").offset();
      scrollOffset = $(window).scrollTop();
      offsetX = canvasOffset.left;
      offsetY = canvasOffset.top-scrollOffset;
    }

    function canvaResize() {
      arts = [];
      container_width = $('.paint-container').width();
      canvasOffset = $("#c1").offset();
      offsetX = canvasOffset.left;
      offsetY = canvasOffset.top;
      canvas_width = container_width;

      initCanvasSize();
      initObject();
    }


    $( window ).on('resize', function() {
      canvaResize();
    });

    function initCanvasSize() {
      var bg_image_url = $('#c1').css('background-image'), bg_image;
      bg_image_url = bg_image_url.match(/^url\("?(.+?)"?\)$/);
      if (bg_image_url[1]) {
        bg_image_url = bg_image_url[1];
        bg_image = new Image();

        $(bg_image).load(function () {
            var multiply = bg_image.height/bg_image.width;
            $('#c1').attr('height', canvas_width*multiply);
            $('#c1').attr('width', canvas_width);

            if (!init) {
              arts = [];
              initObject()
              init = true;
            }
            
            drawAllObjects();
        });
        bg_image.src = bg_image_url;
      }
    }

    initCanvasSize();

    function initObject() {
      var cal = calPxTomm()

      var px_to_mm = cal.px_mm;

      makeObject(canvas_width/2, 100, (art_width/px_to_mm), (art_height/px_to_mm), ob_image);
    }

    function makeObject(x, y, width, height, fill) {

        var art = {
            x: x,
            y: y,
            width: width*art_scale,
            height: height*art_scale,
            right: x + width*art_scale,
            bottom: y + height*art_scale,
            fill: fill
        }

        arts.push(art);
        return (art);
    }

    function drawAllObjects(top, bottom) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        drawTopLine(top);
        drawBottomLine(bottom);

        for (var i = 0; i < arts.length; i++) {
            var art = arts[i]
            drawArt(art);

            var cal = calPxTomm()

            var inner = (art_paspaper/cal.px_mm*art_scale);
            var outer = (art_frame/cal.px_mm*art_scale);

            var inner_outer = inner+outer;

          if(art_is_frame) {
            ctx.lineWidth = outer;
            ctx.shadowColor = '#00000050';
            ctx.shadowBlur = 5;
            ctx.shadowOffsetX = 0;
            ctx.shadowOffsetY = 2;
            ctx.strokeStyle = art_frame_color;
            ctx.strokeRect(art.x-(inner_outer/2+(inner/2)), art.y-(inner_outer/2+(inner/2)), art.width+inner_outer+inner, art.height+inner_outer+inner);
          }

          if(art_is_paspaper && art_is_frame) {
            ctx.lineWidth = inner;
            ctx.shadowColor = '#00000050';
            ctx.shadowBlur = 0;
            ctx.shadowOffsetX = 0;
            ctx.shadowOffsetY = 0;
            ctx.strokeStyle = art_paspaper_color;
            ctx.strokeRect(art.x-(inner/2), art.y-(inner/2), art.width+inner, art.height+inner);
          }

          if (art_is_frame) {
            ctx.shadowColor = '#00000050';
            ctx.shadowBlur = 0;
            ctx.shadowOffsetX = 0;
            ctx.shadowOffsetY = 0;
          } else {
            ctx.shadowColor = '#00000050';
            ctx.shadowBlur = 5;
            ctx.shadowOffsetX = 0;
            ctx.shadowOffsetY = 2;
          }
          ctx.drawImage(art.fill, art.x, art.y, art.width, art.height);

            
        }
    }

    function drawArt(art) {
        // ctx.beginPath();
        // ctx.moveTo(art.x, art.y);
        // ctx.lineTo(art.right, art.y);
        // ctx.lineTo(art.right, art.y + art.height / 2);
        // ctx.lineTo(art.right, art.bottom);
        // ctx.lineTo(art.x, art.bottom);
        // ctx.closePath();

      var cal = calPxTomm()

      var frame_pass = art_paspaper/cal.px_mm*art_scale+art_frame/cal.px_mm*art_scale;
      ctx.beginPath();
      ctx.moveTo(art.x-frame_pass, art.y-frame_pass);
      ctx.lineTo(art.right+frame_pass, art.y-frame_pass);
      ctx.lineTo(art.right+frame_pass, (art.y-frame_pass) + art.height/2);
      ctx.lineTo(art.right+frame_pass, art.bottom+frame_pass);
      ctx.lineTo(art.x-frame_pass, art.bottom+frame_pass);
      ctx.closePath();
    }

    function calPxTomm() {
      var top_value = $('#topline').val();
      var bottom_value = $('#bottomline').val();
      var canvas_height = $('#c1').height();
      var top_px = top_value*(canvas_height/100);
      var bottom_px = bottom_value*(canvas_height/100);
      var wall_height_mm = $('#wall_height').val();
      var wall_px = Math.abs(top_px - bottom_px);
      var px_to_mm = wall_height_mm / wall_px;

      var cal = {
        px_mm: px_to_mm,
        top: top_px,
        bottom: bottom_px
      };

      return cal;
    }

    $(document).on('input', '#topline, #bottomline, #wall_height', function() {

      var cal = calPxTomm()

      var px_to_mm = cal.px_mm;
      var top_px = cal.top;
      var bottom_px = cal.bottom;

      arts = [];

      makeObject(lastX, lastY, (art_width/px_to_mm), (art_height/px_to_mm), ob_image);
      
      drawAllObjects(top_px, bottom_px);
    })


    $(document).on('input', '#topline, #bottomline', function() {
      customThumb();
    })

    function drawTopLine(top) {
      ctx.beginPath();
      ctx.moveTo(0, top);
      ctx.lineTo(canvas_width, top);
      ctx.lineWidth = 1;
      ctx.strokeStyle = "#00000050";
      ctx.stroke();
      ctx.closePath();
    }

    function drawBottomLine(bottom) {
      ctx.beginPath();
      ctx.moveTo(0, bottom);
      ctx.lineTo(canvas_width, bottom);
      ctx.lineWidth = 1;
      ctx.strokeStyle = "#00000050";
      ctx.stroke();
      ctx.closePath();
    }

    function handleMouseDown(e) {
        mouseX = parseInt(e.clientX - offsetX);
        mouseY = parseInt(e.clientY - offsetY);

        lastX = mouseX;
        lastY = mouseY;
        mouseIsDown = true;

    }

    function handleMouseUp(e) {
        mouseX = parseInt(e.clientX - offsetX);
        mouseY = parseInt(e.clientY - offsetY);

        mouseIsDown = false;
    }

    function handleMouseMove(e) {
        mouseX = parseInt(e.clientX - offsetX);
        mouseY = parseInt(e.clientY - offsetY);

        if (ctx.isPointInPath(mouseX, mouseY)) {
          $('#c1').css('cursor', 'all-scroll');
        } else {
          $('#c1').css('cursor', 'default');
        }

        if (!mouseIsDown) {
            return;
        }

        for (var i = 0; i < arts.length; i++) {
            var art = arts[i];
            drawArt(art);
            if (ctx.isPointInPath(lastX, lastY)) {
              art.x += (mouseX - lastX);
              art.y += (mouseY - lastY);
              art.right = art.x + art.width;
              art.bottom = art.y + art.height;
            }
        }

        lastX = mouseX;
        lastY = mouseY;
        drawAllObjects();
    }

    function handleTouchDown(e) {
      // mouseX = parseInt(e.touches[0].clientX - offsetX);
      // mouseY = parseInt(e.touches[0].clientY - offsetY);

      // lastX = mouseX;
      // lastY = mouseY;
      mouseIsDown = true;

  }

  function handleTouchUp(e) {
      // console.log(e.touches)
      // mouseX = parseInt(e.touches[0].clientX - offsetX);
      // mouseY = parseInt(e.touches[0].clientY - offsetY);

      mouseIsDown = false;
  }

  function handleTouchMove(e) {
      mouseX = parseInt(e.touches[0].clientX - offsetX);
      mouseY = parseInt(e.touches[0].clientY - offsetY);

      if (ctx.isPointInPath(mouseX, mouseY)) {
        $('#c1').css('cursor', 'all-scroll');
      } else {
        $('#c1').css('cursor', 'default');
      }

      if (!mouseIsDown) {
          return;
      }

      for (var i = 0; i < arts.length; i++) {
          var art = arts[i];
          drawArt(art);
          if (ctx.isPointInPath(lastX, lastY)) {
            art.x += (mouseX - lastX);
            art.y += (mouseY - lastY);
            art.right = art.x + art.width;
            art.bottom = art.y + art.height;
          }
      }

      lastX = mouseX;
      lastY = mouseY;
      drawAllObjects();
  }


    $("#c1").on('mousedown', function (e) {
        handleMouseDown(e);
    });
    $("#c1").on('mousemove', function (e) {
        handleMouseMove(e);    
    });
    $("#c1").on('mouseup', function (e) {
        handleMouseUp(e);
    });

    $("#c1").on('touchstart', function (e) {
      e.preventDefault();
      handleTouchDown(e);
    });
    $("#c1").on('touchmove', function (e) {
      e.preventDefault();
      handleTouchMove(e);    
    });
    $("#c1").on('touchend', function (e) {
      e.preventDefault();
      handleTouchUp(e);
    });




  }


// });
